const confirmData = {
  title: 'CONFIRM CHANGE',
  message:
    'This change differs from the expected value. Tap continue to confirm the change is correct or cancel to keep the existing value.',
  cancelText: 'Cancel',
  successText: 'Continue',
} as QuestionConfirmData;

export type QuestionConfirmData = {
  title: string;
  message: string;
  cancelText: string;
  successText: string;
};

export { confirmData };
